import { ESymbolCategory, ISymbolDetail } from '../model';

export const isDummyOptionSymbol = (symbol: string) => {
  const optionMatch = symbol.match(/^([A-Z]+)(\d{8})([CP])(\d+(?:\.\d+)?)$/);
  return optionMatch ? true : false;
};

export const processSymbolDetail = (result: ISymbolDetail | null, symbol: string): ISymbolDetail | null => {
  let resultData = result || null;

  if (resultData && (symbol === 'AAPL' || isDummyOptionSymbol(symbol))) {
    resultData = {
      ...resultData,
      underlyingSymbols: ['AAPL'],
      tradableSecurityTypes: [ESymbolCategory.EQUITIES, ESymbolCategory.OPTION]
    };
  }

  return resultData;
};
